export default __webpack_public_path__ + "static/media/clothes.f4bb457c.svg";